
import { Component, Vue } from "vue-property-decorator";
import PortalServiciosBanner from "@/components/Tramites/PortalServiciosBanner.vue";
import categoryService from "@/services/category.service";
import { getSearchableTramites } from "@/services/tramites-search.service";

interface SearchableTramite {
  id: number;
  title: string;
  description?: string;
  slug: string;
  tags: Array<any>;
}

@Component({
  components: {
    PortalServiciosBanner
  }
})
export default class PortalServiciosHeader extends Vue {
  private search: string | object = "";
  private searchTerm: string = "";
  private tramites: Array<SearchableTramite> = [];
  private filteredTramites: Array<any> = [];

  get searchFieldLabel() {
    return this.$q.screen.xs
      ? "Buscar trámite o servicio"
      : "Escribe el nombre del trámite o servicio que buscas";
  }

  private async mounted() {
    try {
      const response = await categoryService.getTramites();
      this.tramites = getSearchableTramites(response).map((tramite: any) => ({
        id: tramite.id,
        title: tramite.name.toUpperCase(),
        description: tramite.description,
        slug: tramite.slug,
        tags: tramite.tags || []
      }));
    } catch (error) {
      this.tramites = [];
    }
  }

  private inputTramites(value: string) {
    this.searchTerm = value || "";
    this.search = this.searchTerm;
  }

  private filterFn(
    value: string,
    update: (callback: () => void) => void
  ): void {
    update(() => {
      const needle = this.normalizeText(value);

      this.filteredTramites = needle
        ? this.tramites
            .filter(tramite => this.matchesSearchTerm(tramite, needle))
            .map(tramite => ({
              label: tramite.title,
              value: tramite.id,
              slug: tramite.slug
            }))
        : [];
    });
  }

  get highlightedOptions() {
    return this.filteredTramites.map(option => ({
      ...option,
      highlightedLabel: this.highlightMatch(option.label)
    }));
  }

  private highlightMatch(text: string) {
    const normalizedSearch = this.normalizeText(this.searchTerm);
    const matchIndex = this.normalizeText(text).indexOf(normalizedSearch);

    if (!normalizedSearch || matchIndex === -1) {
      return text;
    }

    const match = text.substring(
      matchIndex,
      matchIndex + this.searchTerm.length
    );

    return text.replace(match, `<b>${match}</b>`);
  }

  private buscarTramite() {
    const term = this.searchTerm.trim();

    if (term) {
      this.$router.push(`/busqueda-tramites/${encodeURIComponent(term)}`);
    }
  }

  private goToTramite(slug: string) {
    if (!slug) {
      return;
    }

    this.$router.push({
      path: `/portal-servicios/${slug}`,
      query: { scrollTo: "title" }
    });
  }

  private normalizeText(text: any) {
    return (text || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }

  private matchesSearchTerm(
    tramite: SearchableTramite,
    normalizedNeedle: string
  ) {
    const searchableText = [
      tramite.title,
      tramite.description || "",
      ...tramite.tags.map((tag: any) => (tag && tag.name ? tag.name : ""))
    ].join(" ");

    return this.normalizeText(searchableText).includes(normalizedNeedle);
  }
}
